module.exports = __webpack_public_path__ + "media/V84.0feadae7.mp4";